<template>
  <div class="order-table-wrapper">
    <b-table
      tbody-tr-class="order-row"
      table-class="table-class"
      :fields="fields"
      :items="items"
      responsive
      hover
    >
      <template v-slot:cell(OrderId)="data">{{data.item.id}}</template>
      <template v-slot:cell(Date)="data">{{ $moment(data.item.createdAt.toDate()).fromNow()}}</template>
      <template
        v-slot:cell(Customer)="data"
      >{{data.item.details.name?data.item.details.name:'guest'}}</template>
      <template v-slot:cell(Total)="data">{{data.item.total| currency('€')}}</template>
      <template v-slot:cell(Status)="data">
        <b-dropdown
          :variant="`${data.item.status===1?'primary':''}${data.item.status===2?'info':''}${data.item.status===3?'success':''}${data.item.status===4?'danger':''}`"
          id="dropdown-1"
          size="sm"
          pill
          right
          dropleft
          class="p-0"
        >
          <template #button-content>
            <span v-if="data.item.status===1">Processing</span>
            <span v-if="data.item.status===2">Dispatch</span>
            <span v-if="data.item.status===3">Completed</span>
            <span v-if="data.item.status===4">Cancelled</span>
          </template>
          <b-dropdown-item @click="ChangeOrderStatus(data.item.id,1)" :active="data.item.status===1">Processing</b-dropdown-item>
          <b-dropdown-item @click="ChangeOrderStatus(data.item.id,2)" :active="data.item.status===2">Dispatch</b-dropdown-item>
          <b-dropdown-item @click="ChangeOrderStatus(data.item.id,3)" :active="data.item.status===3">Completed</b-dropdown-item>
          <b-dropdown-item @click="ChangeOrderStatus(data.item.id,4)" :active="data.item.status===3">Cancelled</b-dropdown-item>
        </b-dropdown>
      </template>
      <template v-slot:head(Dropdown)>
        <div></div>
      </template>
      <template #cell(Dropdown)="row">
        <b-icon
          @click="row.toggleDetails"
          :icon="row.detailsShowing? 'caret-up-square-fill':'caret-down-square-fill'"
        ></b-icon>
        <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
      </template>

      <template #row-details="row">
        <b-card>
          <b-table small :fields="itemsFields" :items="itemsArray(row.item.order)" responsive hover>
            <template v-slot:cell(IMG)="data">
              <b-img :src="data.item.img[0]" width="64" class="rounded"></b-img>
            </template>
            <template v-slot:cell(SKU)="data">{{data.item.id}}</template>
            <template v-slot:cell(Name)="data">{{data.item.name}}</template>
            <template v-slot:cell(Price)="data">{{data.item.price| currency('€')}}</template>
            <template v-slot:cell(Qty)="data">X{{data.item.quantity}}</template>
            <template v-slot:cell(Total)="data">{{itemTotal(data.item)| currency('€')}}</template>
          </b-table>
          <div class="order-details">
            <p class="h6">Order Type: {{row.item.type}}</p>
            <template v-if="row.item.type==='In-House Order'">
              <p class="order-details-text">Table Number: {{row.item.details.number}}</p>
              <p class="order-details-text" v-if="row.item.details.message">Message: {{row.item.details.message}}</p>
            </template>
            <template v-if="row.item.type==='Pick Up'">
              <p class="order-details-text">Name: {{row.item.details.name}}</p>
              <p class="order-details-text">Email: {{row.item.details.email}}</p>
              <p class="order-details-text">Phone Number: {{row.item.details.number}}</p>
              <p class="order-details-text" v-if="row.item.details.message">Message: {{row.item.details.message}}</p>
            </template>
            <template v-if="row.item.type==='Delivery'">
              <p class="order-details-text">Name: {{row.item.details.name}}</p>
              <p class="order-details-text">Email: {{row.item.details.email}}</p>
              <p class="order-details-text">Phone Number: {{row.item.details.number}}</p>
              <p class="order-details-text">Address: {{row.item.details.address}}</p>
              <p class="order-details-text" v-if="row.item.details.message">Message: {{row.item.details.message}}</p>
            </template>
          </div>
        </b-card>
      </template>
    </b-table>
  </div>
</template>

<script>
import {mapActions} from  "vuex"
export default {
  props: {
    items: Array
  },
  components: {
    //CustomModal
  },
  data() {
    return {
      fields: ["OrderId", "Date", "Customer", "Total", "Status", "Dropdown"],
      itemsFields: ["IMG", "SKU", "Name", "Price", "Qty", "Total"]
    };
  },
  methods: {
    
...mapActions({
    changeOrderStatus:"Order/changeOrderStatus"
}),
ChangeOrderStatus(orderId,status){
    this.changeOrderStatus({orderId,status})
},
    itemsArray(itemsObject) {
      let items = [];
      Object.values(itemsObject).forEach(x => {
        return items.push(x);
      });
      return items;
    },
    itemTotal(item) {
      return item.price * item.quantity;
    }
  },
  computed: {}
};
</script>

<style scoped>
.order-table-wrapper >>> .order-row td {
  vertical-align: top;
}

.order-table-wrapper >>> .order-row {
  border-bottom: 2px solid white;
}

.order-details-text{
  font-size: 12px;
}

/* .order-table-wrapper >>> .order-row td:first-child:before {
  content: "";
  position: absolute;
  border-radius: 5px 0 0 5px;
  background-color: white;
  width: 2px;
  height: 100%;
  left: 0;
  top: 0px;
}
.order-table-wrapper >>> .order-row td:last-child {
  border-radius: 0 5px 5px 0;
}

.order-table-wrapper >>> .order-row  {
  position: relative;
  padding: 6px 10px;
  border: 2px ridge white;
  overflow-x: hidden;
}
 */
/* .order-table-wrapper >>> .table-class{
    border-collapse: unset !important;
} */
</style>